// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__2gYS8","text":"loading_text__2aN4S"};